module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-page-layout', {
    staticClass: "EntrustDetail",
    attrs: {
      "config": _vm.pageConfig
    }
  }, [_c('el-table', {
    attrs: {
      "loading": _vm.IsLoading,
      "element-loading-text": "加载中",
      "data": [_vm.DataDetail]
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "委托单",
      "prop": "Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户订单号",
      "prop": "ReferenceCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "委托类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-col', [_vm._v(_vm._s(_vm._f("DelegationType")(props.row.DelegationType)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('h3', {
    staticStyle: {
      "line-height": "3em"
    }
  }, [_vm._v("物料清单")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "loading": _vm.IsLoading,
      "element-loading-text": "加载中",
      "data": _vm.DataDetail.Lines
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户物料名称："
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("NullShow")(props.row.CustomerProductName)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "客户物料编码："
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("NullShow")(props.row.CustomerProductCode)))])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物料名称/编码",
      "width": "260px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-col', [_vm._v(_vm._s(props.row.Product.Name))]), _vm._v(" "), _c('el-col', [_vm._v("物料编码:" + _vm._s(props.row.Product.Code))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品项"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm._f("ConditionColor")(props.row.Condition.Name)
          }
        }, [_vm._v(_vm._s(props.row.Condition.Name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌",
      "prop": "Product.Brand.Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "机型",
      "prop": "Product.Model.Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "模块",
      "prop": "Product.Module.Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "Quantity"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "委托时长"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-col', [_vm._v(_vm._s(props.row.DelegationPeriodDays) + "天")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "报价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-col', [_vm._v(_vm._s(_vm._f("amount")(props.row.DelegationUnitPrice)))])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77c6064b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Order/EntrustDetail_order.vue
// module id = 755
// module chunks = 0